import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga';

document.body.dir = 'rtl';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();


function initializeReactGA() {
    ReactGA.initialize('UA-145924741-1');
    ReactGA.pageview('/');
}

initializeReactGA()